import createCRUDObservable from 'redux-observable-crud'
import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs'

import TeacherDistributionActions, { TeacherDistributionRedux, TeacherDistributionTypes } from '../Redux/TeacherDistributionRedux'
import { notificationFail } from '../Redux/NotificationActions'

const teacherDistributionCrudObservable = createCRUDObservable({
  mainRedux: TeacherDistributionRedux,
  reduxPath: 'teacherDistribution',
})

const teacherDistributionExcelEpic = (action$, store, { Api }) =>
  action$.ofType(TeacherDistributionTypes.TeacherDistributionExcelRequest)
    .mergeMap(() => (
      Observable
        .fromPromise(Api.teacherDistribution.getTeacherDistributionExcel()
          .then(response => response)
          .catch(error => error))
        .flatMap((response) => {
          const { status } = response
          if (!(status >= 200 && status < 300)) {
            return [notificationFail('Falló la descarga')]
          }
          const file = response.headers['content-disposition']
          const index = file.indexOf('=')
          const fileName = file.substring(index + 1, file.length)
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
          return [
            TeacherDistributionActions.TeacherDistributionExcelSuccess(),
          ]
        })
    ))

export const teacherDistributionObservers = Object.assign({}, teacherDistributionCrudObservable.observers, {})

export const teacherDistributionEpic = combineEpics(
  teacherDistributionCrudObservable.epic,
  teacherDistributionExcelEpic,
)



// WEBPACK FOOTER //
// ./src/Data/Observables/TeacherDistributionObservable.js